// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2rAD0","inner":"Footer_inner__2-Q3z"};